<template>
  <v-row class="actions">
    <v-col>
      <v-alert
        type="success"
        v-if="saved"
      >
        Data was successfully saved.
      </v-alert>
      <v-btn
        color="primary"
        class="mr-4"
        @click="saveData"
        :loading="loading"
      >
        Save
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'FormActions',
    props: {
      saved: {
        default: false,
      },
      loading: {
        default: false,
      },
    },
    methods: {
      saveData () {
        this.$emit('saveData')
      },
    },
  }
</script>

<style scoped>
.actions {
  background-color: #f3f3f3;
}
</style>
